import {
    CHANGE_SCREEN,
    CLOSE_SCREENS,
    OPEN_SCREENS,
    OPEN_PARKING_LOT_POPUP,
    CLOSE_PARKING_LOT_POPUP
 } from './types';

export const changeScreen = clickedTab => dispatch => dispatch({
    type: CHANGE_SCREEN,
    screenToDisplay: clickedTab
});

export const toggleVisibility = visible => dispatch => {
    if(!visible) {
        dispatch({
            type: OPEN_SCREENS,
        });
    } else {
        dispatch({
            type: CLOSE_SCREENS,
        });
    }
}

export const openScreens = () => dispatch => dispatch({
    type: OPEN_SCREENS,
});

export const closeScreens = () => dispatch => {
    dispatch({
        type: CLOSE_SCREENS,
    });
}

export const openParkingLotPopup = () => dispatch => dispatch({
    type: OPEN_PARKING_LOT_POPUP,
});

export const closeParkingLotPopup = () => dispatch => dispatch({
    type: CLOSE_PARKING_LOT_POPUP,
});